import React, { useEffect, useState } from 'react'
import { Dropdown } from 'antd';
import { Avatar } from 'antd'
import { AiFillMessage } from "react-icons/ai";
import { GoAlertFill } from "react-icons/go";
import { formattedDateTime, getInitials } from '../../../../../../../config/utils';
import './style.css'
import Modal from '../../../../../../../components/Modal';
import ReportPostPoll from '../../../PostHeader/ReportPollPost';
import { useSelector } from 'react-redux';

const SharedPostHeader = ({ data }) => {
    const [headerData, setHeaderData] = useState({
        imageUrl: null,
        fullName: null,
        createdAt: null
    })
    const [openReportModal, setOpenReportModal] = useState(false)

    const user = useSelector(state => state?.auth?.loggedInUser)
    const items = [
        {
            label: 'Message',
            key: '0',
            icon: <AiFillMessage className='icon-msg' />,
        },
        {
            type: 'divider',
        },
        {
            label: 'Report',
            key: '1',
            icon: <GoAlertFill className='icon-alert' />,
        }
    ]

    const handleMenu = (e) => {
        if(e.key == 1){
            setOpenReportModal(true)
        }
    }

    const menuProps = {
        items,
        onClick: handleMenu
    };

    const closeModal = () => {
        setOpenReportModal(false)
    }

    useEffect(() => {
        setHeaderData({
            imageUrl: (data && data?.originalPost) ? data?.originalPost?.user?.imageThumbUrl : data?.user?.imageThumbUrl,
            fullName: (data && data?.originalPost) ? data?.originalPost?.user?.fullName : data?.user?.fullName,
            createdAt: (data && data?.originalPost) ? data?.originalPost?.createdAt : data?.createdAt,
        });
    }, [data]); 

    return (
        <React.Fragment>
            {headerData && (
                <React.Fragment>
                    <div id='post-detail-header' className='header flex justify-between items-center mb-2'>
                        <div className='flex justify-start items-center'>
                            <Avatar size={50} src={headerData?.imageUrl} alt="avatar">
                                {getInitials(headerData?.fullName)}
                            </Avatar>
                            <div className='flex flex-col pl-2'>
                                <h5 className='heading-5 font-bold mb-0'>{headerData?.fullName}</h5>
                                <small className='text-slate-500 font-medium'>{formattedDateTime(headerData?.createdAt)}</small>
                            </div>
                        </div>
                        { data && data?.user?.id != user?.id && (
                        <div className='dropdown'>
                            <Dropdown.Button menu={menuProps} trigger={['click']}>
                            </Dropdown.Button>
                        </div>
                        )}
                    </div>
                    <hr className='border-dashed border-1 border-gray-200 mb-4' />
                </React.Fragment>
            )}
            <Modal.Basic open={openReportModal} onCancel={closeModal} width={300}>
                <div className="p-4">
                    <ReportPostPoll postData={data} closeModal={closeModal} />
                </div>
            </Modal.Basic>
        </React.Fragment>
    )
}

export default SharedPostHeader

